import { TipoPersona } from 'npm-modelado-catering';


export class AsociacionPersonaDTO {    
    public idAsociacionPersona?: number;
    public idUnidad?: string;
    public nombreUnidad?: string;
    public idPersona?: string;    
    public nombrePersona?: string;
    public nombreTipoPersona?: string;    
    public tipoPersona?: TipoPersona;    
    public estadoDependencia?: string;  
    public estaActivoParaDependencia?: string;
    public fechaCreacion?: Date;
    public usuarioCreacion?: string;
    public correo?: string;
    public identificacion?: string;
}

